// MOLA (comportamento, nao animacao de tempo fixo): partindo do valor atual e da velocidade atual, o movimento pode ser agarrado e redirecionado
// a qualquer instante. "damping" 1 = sem ressalto (padrao); ~0,8 = um pouco de ressalto, so quando o gesto trouxe impulso. "response" = rapidez em segundos.
export interface OpcoesMola { damping?: number; response?: number; velocidade?: number }
export interface Mola {
  readonly x: number; readonly v: number; readonly ativo: boolean
  set(x: number): void; para(): void; vai(alvo: number, o?: OpcoesMola): void
  aoMover(f: (x: number, v: number) => void): void; aoFim(f: () => void): void
}
export function criarMola(): Mola {
  let x = 0, v = 0, alvo = 0, z = 1, resp = 0.4, raf = 0, ult = 0
  let tick: (x: number, v: number) => void = () => {}, fim: () => void = () => {}
  const passo = (t: number) => {
    const dt = Math.min(0.032, (t - ult) / 1000); ult = t
    const w = (2 * Math.PI) / resp, k = w * w, c = 2 * z * w, n = 8, h = dt / n               // subpassos: o erro numerico nao altera o amortecimento
    for (let i = 0; i < n; i++) { const a = -k * (x - alvo) - c * v; v += a * h; x += v * h }
    tick(x, v)
    if (Math.abs(v) < 0.05 && Math.abs(x - alvo) < 0.05) { x = alvo; v = 0; tick(x, 0); raf = 0; fim(); return }
    raf = requestAnimationFrame(passo)
  }
  return {
    get x() { return x }, get v() { return v }, get ativo() { return !!raf },
    set(val) { x = val; tick(x, v) },
    para() { if (raf) cancelAnimationFrame(raf); raf = 0; v = 0 },
    vai(a, o = {}) { alvo = a; z = o.damping == null ? 1 : o.damping; resp = o.response || 0.4; if (o.velocidade != null) v = o.velocidade; if (!raf) { ult = performance.now(); raf = requestAnimationFrame(passo) } },
    aoMover(f) { tick = f }, aoFim(f) { fim = f },
  }
}
// onde um gesto vai parar se continuar (decaimento exponencial, o mesmo do scroll): usa a velocidade de soltura em px/s
export const projetar = (vel: number, taxa = 0.998) => ((vel / 1000) * taxa) / (1 - taxa)
// resistencia progressiva na borda: quanto mais passa do limite, menos o elemento acompanha
export const elastico = (sobra: number, dim: number, c = 0.55) => (sobra * dim * c) / (dim + c * Math.abs(sobra))
export const maisPerto = (pontos: number[], alvo: number) => pontos.reduce((m, p) => (Math.abs(p - alvo) < Math.abs(m - alvo) ? p : m), pontos[0])
export const prefereMovimentoReduzido = () => { try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches } catch { return false } }
